import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

import AjaxService from '../../Services/Ajax/index.jsx';

import CMSContent from '../CMSContent/index.jsx';
import LoadingOverlay from '../LoadingOverlay/index.jsx';


class CheckoutDurationSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: undefined,
      loading: false,
      error: null
    };

    this.body = undefined;

    this.onPostComplete = this.onPostComplete.bind(this);
  }

  handleClick(variantId) {
    this.setState({ loading: true, error: null });

    AjaxService.post('cs:checkout-duration-selector', 'variant=' + variantId)
      .then(this.onPostComplete);
  }

  componentDidMount() {
    this.body = jQuery(document.body);
  }

  onPostComplete(response) {
    var newState = { loading: false };

    if (response.error) {
      newState.error = response.message;
    } else {
      newState.current = response.data;
      newState.error = null;

      // tell the rest of the checkout process that things have changed.
      this.body.trigger('update_checkout', { update_shipping_method: false });
    }

    this.setState(newState);
  }

  render() {
    var content = [];
    var groups = [];

    if (this.state.error) {
      content.push(
        <Alert key="error" variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          {this.state.error}
        </Alert>
      )
    }

    var current = this.props.current;
    if (this.state.current) {
      current = this.state.current;
    }

    if (this.props.group) {
      var currency = this.props.currency;

      var mostExpensive = -1;
      for (var i = 0; i < this.props.group.length; i++) {
        var group = this.props.group[i];

        if (group.monthlyPrice > mostExpensive) {
          mostExpensive = group.monthlyPrice;
        }
      }

      for (var i = 0; i < this.props.group.length; i++) {
        const group = this.props.group[i];
        var savings = null;
        var conditions = '';

        var price = '$' + group.monthlyPrice + ' /month';
         
        if (group.monthlyPrice < mostExpensive) {
          var percentage = Math.round(100 - (group.monthlyPrice / mostExpensive * 100));
          savings = (
            <div className="cs-discount text-white">
              SAVE {percentage}%<br />
            </div>
          );
        } else {
          savings = (
            <React.Fragment>&nbsp;<br /></React.Fragment>
          );
        }

        if (this.props.trial) {
          conditions = '7-day trial then ' + price;
        } else {
          conditions = price;
        }

        switch (group.duration) {
          case 'Yearly':
            conditions = conditions + ', paid annually';
            break;
          case 'Every 4 Months':
            conditions = conditions + ', paid every 4 months';
            break;
          case 'Every 2 Months':
            conditions = conditions + ', paid every 2 months';
            break;
        }

        if (conditions) {
          conditions = <p className="text-center has-grey-500-color"><small>* {conditions}</small></p>;
          price = price + '*';
        }

        if (group.id == current) {
          var button = (
              <Button variant="outline-primary-shadow" block>
                <h4 className="text-left my-2">{group.duration}</h4>
                <p className="text-left my-2">{currency} {price}</p>
              </Button>
          );
        } else {
          var button = (
            <Button variant="clear-primary-shadow" block onClick={() => this.handleClick(group.id)}>
              <h4 className="text-left my-2">{group.duration}</h4>
              <p className="text-left my-2">{currency} {price}</p>
            </Button>
          );
        }

        groups.push(
          <div key={i} className="cs-checkout-duration-selector__variant">

            <div className="position-relative">
              {savings}
              {button}
            </div>
            <CMSContent>
              {conditions}
            </CMSContent>
          </div>
        );
      }
    }

    content.push(
      <LoadingOverlay key="content" disabled={! this.state.loading}>
        <div className="cs-checkout-duration-selector">
          <div className="cs-checkout-duration-selector__title">

            <CMSContent>
              <span className="cs-step">1</span>
              <h3 dangerouslySetInnerHTML={{ __html: this.props.title }} className="d-inline-flex mx-2"/>
            </CMSContent>

          </div>
          <div className="cs-checkout-duration-selector__variants">
            {groups}
          </div>
        </div>
      </LoadingOverlay>
    );

    return content;
  }
}


export default CheckoutDurationSelector;

